import { createBrowserRouter, type RouteObject } from 'react-router';
import { TerminalDesktop } from './layouts/TerminalDesktop';
import { HomePage } from './pages/home/HomePage';
import { AboutPage } from './pages/about/AboutPage';
import { ContactPage } from './pages/contact/ContactPage';
import { ProjectsPage } from './pages/projects/ProjectsPage';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <TerminalDesktop />,
    children: [
      {
        element: <HomePage />,
        index: true,
      },
      {
        path: '/about',
        element: <AboutPage />,
      },
      {
        path: '/contact',
        element: <ContactPage />,
      },
      {
        path: '/projects',
        element: <ProjectsPage />,
      },
    ],
  },
];

export const router = createBrowserRouter(routes);
